module.exports = __webpack_public_path__ + "img/what-img.b839b111.png";